//LIST_UDEMY_COURSES
export const listYouTubeVideos = (
    youTubeVideos = []
) => ({
    type: 'LIST_YOUTUBE_VIDEOS',
    youTubeVideos
});


// WEBPACK FOOTER //
// ./src/actions/youtube.js